export enum SnApplianceStatus {
  Inactive = 'Inactive',
  Active = 'Active',
  Up = 'Up',
  Down = 'Down',
  Pending = 'Pending',
  Error = 'Error',
}
